import React from 'react';
import { cn } from '@express-labs/raven-tools';
import s from '../Icon.scss';
import { IconV1Props } from '../Icon';

const Grid5: React.FC<IconV1Props> = ({ icon }) => (
  <svg
    className={cn(s.svg, 'svg-icon--grid', 'svg-icon--grid-5')}
    data-icon={icon}
    viewBox="0 0 19 17"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g className={s.gridFill} fillRule="evenodd">
      <path d="M4 0h3v5H4zM8 0h3v5H8zM12 0h3v5h-3zM12 6h3v5h-3zM16 0h3v5h-3zM4 6h3v5H4zM8 6h3v5H8zM16 6h3v5h-3zM12 12h3v5h-3zM4 12h3v5H4zM0 0h3v5H0zM0 6h3v5H0zM0 12h3v5H0zM8 12h3v5H8zM16 12h3v5h-3z" />
    </g>
  </svg>
);

export default Grid5;
